<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">{{$t('m.Introduction')}}</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">FAX</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">什么是区块链中间件</a></p>
          <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">FaxChain 资源管理器</a></p>
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">{{$t('m.KeyFeatures')}}</a></p>
          <div class="subAnchor">
            <p @click="activeted(6)" class="s2"><a :class="{active:flag==6}" href="#box6">{{$t('m.Speed')}}</a></p>
            <p @click="activeted(7)" class="s2"><a :class="{active:flag==7}" href="#box7">{{$t('m.Scalability')}}</a></p>
            <p @click="activeted(8)" class="s2"><a :class="{active:flag==8}" href="#box8">{{$t('m.Security')}}</a></p>
            <p @click="activeted(9)" class="s2"><a :class="{active:flag==9}" href="#box9">{{$t('m.Flexibility')}}</a></p>
            <p @click="activeted(10)" class="s2"><a :class="{active:flag==10}" href="#box10">{{$t('m.Sustainability')}}</a></p>
            <p @click="activeted(11)" class="s2"><a :class="{active:flag==11}" href="#box11">{{$t('m.SmartContractSupport')}}</a></p>
            <p @click="activeted(12)" class="s2"><a :class="{active:flag==12}" href="#box12">{{$t('m.PrivateAndPublicBlockchains')}}</a></p>
            <p @click="activeted(13)" class="s2"><a :class="{active:flag==13}" href="#box13">{{$t('m.DesignedForFinance')}}</a></p>
          </div>
        </div>
        
      </div>
      <p class="p1">{{$t('m.WhatIsFaxchain')}}?</p>
      <p id="box1" class="p2">{{$t('m.Introduction')}}</p>
      <div class="p3">FaxChain 是由一条主链和两条侧链组成的公链，由FaxChain（Primary Chain）、FaxMax 和 FaxSpace 的逻辑解耦和独立实现。通过唯一的原生激励代币 FAX 驱动，提供了一个开源、安全、可扩展的P2P网络平台，并实现快速交易、低成本、可靠运行。FaxChain 也是去中心化的、不可阻挡的、可以无限持续的社区自治系统，也就是说，所有这些特性使 FaxChain 形成了一个去中心化的虚拟计算机，并永远存在于全球虚拟网络中。</div>
      <div class="p3">FaxChain 为创建去中心化应用程序提供安全高效的基础设施，以便在跨链、数据交换的生态系统中实现各种资产的无缝链上交易。在开发这种以交易为重点的开源区块链技术时，FaxChain 专注于为希望构建新的去中心化交易应用程序的区块链开发人员提供更低的运营成本。这意味着基于 FaxChain 的 DApp 最终用户的费用更低。我们还设计了 FaxChain 来提升去中心化交易的用户体验标准——FaxChain 的基础层经过优化以提供最佳的交易性。</div>
      <!-- <div class="p3">FaxChain 是世界上第一个交易链——为交易而构建的区块链技术。这是去中心化交易发展的下一步，人们可以在链上交易任何有价值的东西，并拥有和控制他们交易的资产。</div> -->
      <!-- <div class="p3">FaxChain 为创建去中心化应用程序提供安全高效的基础设施，以便在跨链、价值交换的生态系统中实现各种资产的无缝链上交易。</div> -->
      <!-- <div class="p3">在开发这种以交易为重点的开源区块链技术时，FaxChain 专注于为希望构建新的去中心化交易应用程序的区块链开发人员提供更低的运营成本。这意味着基于 FaxChain 的 DApp 最终用户的费用更低。我们还设计了 FaxChain 来提升去中心化交易的用户体验标准——FaxChain 的基础层经过优化以提供最佳的交易性能和体验。</div> -->
      <div id="box2" class="p2">FAX</div>
      <div class="p3">你有 FAX 代币吗？借助 FAX，您拥有为 FaxChain 的安全和治理做出贡献的独特能力。将您的 FAX 委托给 FaxChain 区块链上 100 个验证者中的一个或多个，以通过权益证明获得更多 FAX。您还可以通过链上治理提案与您的 FAX 一起投票，以影响 FaxChain 的未来。</div>
      <div class="p3">申请成为验证人需要至少质押 1,000 FAX。此外，还需要存入一定数量的 FAX 才能提交链式治理提案或执行挂单操作。</div>
      <div class="p3">FAX 持有者通过质押他们的代币获得投票权，该地址支持的每个验证人候选人的票数等于该地址质押的 FAX 数量。</div>
      <div id="box3" class="p2">什么是区块链中间件？</div>
      <div class="p3">通常在区块链行业，开发者分为以下几类：</div>
      <div class="p3">
        <ul style="padding-left:15px">
            <li>第一个是公链开发者，负责底层技术的开发。公链开发具有研发周期长、进入门槛高的特点。</li>
            <li>二是基础设施开发者，负责基础设施开发，如钱包、区块链浏览器、交易所等。</li>
            <li>第三个是应用开发者，负责应用开发，比如2020年的DeFi App。这类开发者对技术和运营创新的要求更高。</li>
        </ul>
      </div>
      <div class="p3">随着互联网的发展，随着区块链技术的成熟，公链将承担更复杂的业务。因此，去中心化的业务需要一个深入的开发环境。FaxChain 就是为这些开发者设计的。</div>
      <div class="p3">在互联网应用程序中，中间件是搭建系统软件和应用软件之间桥梁的软件。中间件使应用程序能够在不同的技术架构之间共享信息和资源，例如进程调度、消息队列、数据存储、事务处理等，以及广泛应用于能源、电信、金融、银行、医疗、教育等行业软件，降低软件开发成本。</div>
      <div class="p3">基于此，FaxChain 提出“区块链中间件”的概念，以降低应用开发者的开发成本。</div>
      <div id="box4" class="p2">FaxChain 资源管理器</div>
      <div class="p3">FaxChain 区块浏览器允许您搜索、查看和分析 FaxChain 数据——如区块、交易、验证者以及其他关键信息。</div>
      <div class="p3">
        <ul style="padding-left:15px">
            <li><a href="http://www.faxscan.org/">FaxChain link</a></li>
        </ul>
      </div>
      <div id="box5" class="p2">{{$t('m.KeyFeatures')}}</div>
      <div id="box6" class="p4">{{$t('m.Speed')}}</div>
      <div class="p3">使用由康奈尔计算机科学家团队开发的新型共识协议，能够在 1 秒内永久确认交易。</div>
      <div id="box7" class="p4">{{$t('m.Scalability')}}</div>
      <div class="p3">每秒可处理 4,500 笔交易——比现有区块链高出一个数量级。</div>
      <div id="box8" class="p4">{{$t('m.Security')}}</div>
      <div class="p3">确保更强大的安全保障，远高于其他网络的 51% 标准。</div>
      <div id="box9" class="p4">{{$t('m.Flexibility')}}</div>
      <div class="p3">轻松创建包含几乎任何任意逻辑的自定义区块链和去中心化应用程序。</div>
      <div id="box10" class="p4">{{$t('m.Sustainability')}}</div>
      <div class="p3">使用节能的权益证明共识算法而不是工作量证明。</div>
      <div id="box11" class="p4">{{$t('m.SmartContractSupport')}}</div>
      <div class="p3">支持创建 Solidity 智能合约和您最喜欢的以太坊工具，如 Remix、Metamask、Truffle 等。</div>
      <div id="box12" class="p4">{{$t('m.PrivateAndPublicBlockchains')}}</div>
      <div class="p3">创建您自己的公共或私有区块链。</div>
      <div id="box13" class="p4">{{$t('m.DesignedForFinance')}}</div>
      <div class="p3">原生支持使用复杂的自定义规则集轻松创建和交易数字智能资产。</div>
    </div>
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">{{$t('m.Introduction')}}</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">FAX</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">什么是区块链中间件</a></p>
      <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">FaxChain 资源管理器</a></p>
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">{{$t('m.KeyFeatures')}}</a></p>
      <div class="subAnchor">
        <p @click="activeted(6)" class="s2"><a :class="{active:flag==6}" href="#box6">{{$t('m.Speed')}}</a></p>
        <p @click="activeted(7)" class="s2"><a :class="{active:flag==7}" href="#box7">{{$t('m.Scalability')}}</a></p>
        <p @click="activeted(8)" class="s2"><a :class="{active:flag==8}" href="#box8">{{$t('m.Security')}}</a></p>
        <p @click="activeted(9)" class="s2"><a :class="{active:flag==9}" href="#box9">{{$t('m.Flexibility')}}</a></p>
        <p @click="activeted(10)" class="s2"><a :class="{active:flag==10}" href="#box10">{{$t('m.Sustainability')}}</a></p>
        <p @click="activeted(11)" class="s2"><a :class="{active:flag==11}" href="#box11">{{$t('m.SmartContractSupport')}}</a></p>
        <p @click="activeted(12)" class="s2"><a :class="{active:flag==12}" href="#box12">{{$t('m.PrivateAndPublicBlockchains')}}</a></p>
        <p @click="activeted(13)" class="s2"><a :class="{active:flag==13}" href="#box13">{{$t('m.DesignedForFinance')}}</a></p>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Introduction',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>